<template>
  <div>
    <b-breadcrumb style="margin-bottom:20px">
      <b-breadcrumb-item to="/">
        <feather-icon icon="HomeIcon" size="16" class="align-text-top" />
      </b-breadcrumb-item>
      
      <b-breadcrumb-item to="/po-fail" v-if="from=='/po-fail'"
        >PO Fail List</b-breadcrumb-item
      >
      <b-breadcrumb-item to="/kiosk-warehouse" v-else-if="permission.view"
        >Kiosk Warehouse</b-breadcrumb-item
      >
      <b-breadcrumb-item active>Detail Kiosk PO</b-breadcrumb-item>
    </b-breadcrumb>
    <b-card no-body>
      <b-modal v-model="modalCheckStock" title="Check Stock">
        <!-- Modal for checking stock-->
        <b-container>
          <b-row>
            <b-col cols="12">
              <div class="d-flex">
                Sparepart : {{ selectScan.itemModel }}.
              </div>
              <div class="d-flex" v-if="selectScan.replacementItem">
                Replacement Item {{ selectScan.replacementItem.itemModel }}
              </div>
              <div class="d-flex">
                Requested qty : {{ selectScan.updatedQty? selectScan.updatedQty : selectScan.qty }}
              </div>
              <div class="d-flex" v-if="selectScan.replacementItem">
                Replacement Requested qty : {{ selectScan.updatedReplacementQty ? selectScan.updatedReplacementQty : selectScan.availableReplacementQty }}
              </div>
              <div
                v-if="!selectScan.replacementItem"
                class="mt-1"
              >
                <span style="color:red">
                  This item does not have a replacement item yet</span>
              </div>
            </b-col>
          </b-row>
        </b-container>
        <template #modal-footer>
          <div class="w-100 d-flex align-items-center justify-content-between gap-2">
            
            <!-- Only available for first check. if replacement available already selected, should not be selectable anymore -->
            <b-button variant="success" 
            class="flex-fill mx-1" 
            @click="handleStockStatus('Safe')" 
            v-if="!selectScan.replacementItem 
            || (!selectScan.updatedReplacementQty || selectScan.updatedReplacementQty == 0)">
              Stock Available
            </b-button>
            <!-- Only selectable if item has replacement item  -->
            <b-button 
            v-if="selectScan.replacementItem" 
            variant="warning" 
            class="flex-fill mx-1" 
            @click="handleStockStatus('Replacement Item Safe')">
              Replacement Available
            </b-button>
            <!-- Selectable regardless  -->
            <b-button variant="danger" class="flex-fill mx-1" @click="showOutOfStockModal">
              Out of Stock
            </b-button>
          </div>
        </template>
      </b-modal>
      <b-modal v-model="disableButton" centered no-close-on-backdrop hide-footer hide-header>
        <div class="d-flex flex-column align-items-center justify-content-center py-3">
          <b-spinner medium variant="primary" label="Spinning"></b-spinner>
          <p class="mt-3">Processing Purchase Order</p>
        </div>
      </b-modal>
      <b-modal v-model="modalQtyEdit" title="Quantity Need Edit">
        <!-- Modal for checking stock-->
        <b-container>
          <b-row>
            <b-col cols="12">
              <div class="d-flex">
                Requested quantity : {{ selectScan.updatedQty? selectScan.updatedQty : selectScan.qty}}
              </div>
            </b-col>
            <b-col cols="12" class="mt-1">
              <label>Item Available :</label>
              <b-form-group>
                <b-form-input id="edit-qty-to" v-model.number="selectScan.availableQty" type="number" min="1" required></b-form-input>
              </b-form-group>
            </b-col>
            
            <!-- v-select for replacement item -->
            <b-col cols="12" v-if="textItemReplacement !== 'No item Replacement'">
              <label>Replacement Item:</label>
              <b-form-group>
                <b-form-input id="edit-qty-to" v-model="textItemReplacement" disabled></b-form-input>
              </b-form-group>
            </b-col>
            
            <!-- Replacement quantity input -->
            <b-col cols="12" class="mt-1" v-if="textItemReplacement !== 'No item Replacement'">
              <label>Replacement item Available :</label>
              <b-form-group>
                <b-form-input id="replacement-qty" v-model.number="selectScan.availableReplacementQty" type="number" min="1" required></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-container>
        <template #modal-footer>
          <div class="w-100 d-flex justify-content-between align-items-center">
            <b-button variant="success" @click="confirmEditQtyTo">Confirm</b-button>
            <b-button variant="danger" @click="modalQtyEdit = false">Cancel</b-button>
          </div>
        </template>
      </b-modal>
      <b-modal v-model="modalConfirmation" :title="modalTitle">
        <!-- Alert before Delete PO-->
        <b-container>
          <b-row>
            <b-col cols="12" >
              <div class="d-flex">
                Are you sure want to {{ messageModal }} this {{purchase.PONumber}} ?
              </div>
            </b-col>
          </b-row>
        </b-container>
        <template #modal-footer>
          <div class="w-100 d-flex justify-content-center align-items-center">
            <b-button variant="success" class="ml-1" @click="confirmEdit">Confirm</b-button>
          </div>
        </template>
      </b-modal>
      <b-modal v-model="modalSubmitPO" :title="modalTitle">
        <!-- Alert before Delete PO-->
        <b-container>
          <b-row>
            <b-col cols="12" >
              <div class="d-flex">
                Are you sure want to complete this {{purchase.PONumber}} ?
              </div>
            </b-col>
          </b-row>
        </b-container>
        <template #modal-footer>
          <div class="w-100 d-flex justify-content-center align-items-center">
            <b-button variant="success" class="ml-1" @click="confirmPO">Confirm</b-button>
          </div>
        </template>
      </b-modal>
      <b-modal v-model="modalSapError" title="SAP Error" hide-footer centered>
        <div class="d-flex flex-column align-items-center">
          <p class="text-center">SO creation in SAP fail. Counter staff has been notified. No action required at your side. Counter staff will settle this issue.</p>
          <div class="d-flex justify-content-center mt-2">
            <b-button variant="primary" @click="handleSapErrorClose">OK</b-button>
          </div>
        </div>
      </b-modal>
      <b-modal v-model="modalInfo" title="Stock Check Complete" hide-footer centered>
        <div class="d-flex flex-column align-items-center">
          <p class="text-center">Please bring items to counter to verify item type.</p>
          <div class="d-flex justify-content-center mt-2">
            <b-button variant="primary" @click="handleInfoClose">OK</b-button>
          </div>
        </div>
      </b-modal>
      
      <!-- Out of Stock Modal -->
      <b-modal v-model="modalOutOfStock" title="Out of Stock - Add Note">
        <b-container>
          <b-row>
            <b-col cols="12">
              <div class="d-flex">
                Item: {{ selectScan.itemModel }}
              </div>
              <div class="d-flex">
                Requested qty: {{ selectScan.updatedQty ? selectScan.updatedQty : selectScan.qty }}
              </div>
            </b-col>
            <b-col cols="12" class="mt-3">
              <label>Available Quantity:</label>
              <b-form-group>
                <b-form-input 
                  v-model.number="outOfStockData.availableQty" 
                  type="number" 
                  min="0" 
                  placeholder="Enter available quantity"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" class="mt-1">
              <label>Note:</label>
              <b-form-group>
                <b-form-textarea
                  v-model="outOfStockData.note"
                  placeholder="Enter note (e.g., Only have quantity 2)"
                  rows="3"
                  required
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-container>
        <template #modal-footer>
          <div class="w-100 d-flex justify-content-between align-items-center">
            <b-button variant="success" @click="confirmOutOfStock">Confirm Out of Stock</b-button>
            <b-button variant="secondary" @click="cancelOutOfStock">Cancel</b-button>
          </div>
        </template>
      </b-modal>
      <b-card-body title="Detail Kiosk PO">
        <b-col cols="12">
          <b-row>
            <!-- ================================ -->
            <b-col cols="6">
              <b-row>
                <div class="d-flex flex-column">
                  <label>Purchase Order</label>
                  <p class="font-weight-bold">{{ poNumber[0] }}</p>
                </div>
              </b-row>
              <b-row>
                <div class="d-flex flex-column">
                  <label>Order Status</label>
                  <p class="font-weight-bold">{{ purchase.orderStatus === 'PO Fail' ? 'Admin Review' : (purchase.orderStatus == '' ? 'Created' : purchase.orderStatus)}}</p>
                </div>
              </b-row>
              <b-row>
                <div class="d-flex flex-column">
                  <label>Purchase Date</label>
                  <p class="font-weight-bold">
                    {{ dates(purchase.updatedAt) }}
                  </p>
                </div>
              </b-row>
              <b-row>
                <div class="d-flex flex-column">
                  <label>Phone</label>
                  <p class="font-weight-bold">
                    {{ purchase.customerDetail.phone }}
                  </p>
                </div>
              </b-row>
              <b-row>
                <div class="d-flex flex-column">
                  <label>Email</label>
                  <p class="font-weight-bold">
                    {{ purchase.customerDetail.email }}
                  </p>
                </div>
              </b-row>
              <!-- <b-row>
                <div class="d-flex flex-column">
                  <b-button
                    block
                    :disabled="loading"
                    v-show="showPrintButton"
                    variant="secondary"
                    @click="printPO()"
                    ><feather-icon size="16" icon="PrinterIcon" /> Print PO</b-button
                  >
                </div>
              </b-row> -->
            </b-col>

            <b-col cols="6">
              <b-row>
                <div
                  class="d-flex flex-column"
                  v-if="purchase.deliveryType === 'End Customer'"
                >
                  <label>Customer Name</label>
                  <p class="font-weight-bold">
                    {{
                      purchase.customerDetail.type === "Company"
                        ? purchase.customerDetail.companyName
                        : `${purchase.customerDetail.firstName} ${purchase.customerDetail.lastName}`
                    }}
                  </p>
                </div>

                <div
                  class="d-flex flex-column"
                  v-if="purchase.deliveryType === 'Self Collect'"
                >
                  <label>Customer Name</label>
                  <p class="font-weight-bold">
                    {{
                      purchase.customerDetail.firstName === ""
                        ? "Not Set Up"
                        : `${purchase.customerDetail.firstName} ${purchase.customerDetail.lastName}`
                    }}
                  </p>
                </div>
              </b-row>

              <b-row>
                <div class="d-flex flex-column">
                  <label>Remarks</label>
                  <p class="font-weight-bold">
                    {{ purchase.remarks }}
                  </p>
                </div>
              </b-row>
            </b-col>
          </b-row>
          <b-row style="margin-top:25px;">
            <h5>Purchase Order Item List</h5>
            <b-table
                :fields="scanFields"
                :items="purchase.items"
                show-empty
                responsive
                :stacked="stackedStatus">
                <template #cell(model)="row">
                  {{ row.item.replacementItem ? `${row.item.replacementItem.itemModel} - replacement of ${row.item.model}` : row.item.model }}
                </template>
                <template #cell(description)="row">
                  {{ (row.item.replacementItem)?row.item.replacementItem.description:row.item.description }}
                </template>
                <template #cell(actions)="row">
                  <b-button
                    @click="selectItem(row)"
                    variant="primary">Select</b-button>
                </template>
                <template #cell(status)="row">
                  {{ !row.item.status ? "Checking Stock" :( row.item.status == "Safe" ? "Available" : (row.item.status == "Replacement Item Safe" ? 'Replacement Available' : row.item.status)) }}
                </template>
                <template #cell(qty)="row">
                  {{ row.item.updatedQty ? row.item.updatedQty : (row.item.updatedReplacementQty ? row.item.updatedReplacementQty: row.item.qty )}}
                </template>
              </b-table>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="auto">
              <b-button
                v-if="purchase.orderStatus == 'Checking'"
                variant="success"
                class="me-2"
                :disabled="!isCheckStockCompleteEnabled"
                @click="confirmCheckStock"
              >
                Check Stock Complete
              </b-button>
            </b-col>
            <b-col cols="auto">
              <b-button
                v-if="purchase.orderStatus == 'Checking'"
                variant="warning"
                @click="confirmEditPO"
              >
                Request Counter to edit Order
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { userAccess, dateFormat, dateFormatFullWithSecond } from "@/utils/utils";
import stepProgressDaikin from '@/components/StepProgressDaikin.vue'
import { logo, footer,header } from "./daikin-po-img-base64.js";
import axios from "@/axios";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import pdfMake from "pdfmake/build/pdfmake";
import vSelect from "vue-select";
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  components: {
    stepProgressDaikin,
    "v-select": vSelect,
  },
  props: ["id","from"],
  data() {
    return {
      replacementQty:0,
      itemReplacement: "",
      textItemReplacement: "",
      modalQtyEdit : false,
      selectScan: "", //this one variable for save item info after select item to prepare scanning
      doFields: [
        { key: "sapDo", label: "DO Number" },
        { key: "sapInvoice", label: "Invoice Number" },
        { key: "status", label: "Status" },
      ],
      scanFields: [
        {
          key: "model",
          label: "Item Model"
        },
        {
          key: "description",
          label: "Description"
        },
        {
          key: "qty",
          label: "Qty"
        },
        {
          key: "status",
          label: "Status"
        },
        {
          key: "actions",
          label: "Action"
        },
      ],
      doList: [],
      loading: false,
      stackedStatus: "md",
      modalCheckStock : false,
      modalTitle: "",
      modalConfirmation: false,
      messageModal : "",
      modalSubmitPO : false,
      disableButton: false,
      modalSapError: false,
      modalInfo: false,
      modalOutOfStock: false,
      outOfStockData: {
        availableQty: 0,
        note: ''
      },
    };
  },
  methods: {
    ...mapActions({
      addSaleKiosk: "sales/addSaleKiosk"
    }),
    processButtonHandler(status,item){
      if(status == "Safe"){
        this.modalCheckStock = true
      }else if(status == "Replacement Item Safe"){
        this.modalQtyEdit = true
      }else if(status == "Out of Stock"){
        return true
      }else{
        return false
      }
    },

    sapStatus(status){
      switch(status) {
        case 'A':
          return 'Ready'
        case 'B': 
          return 'Partially processed'
        case 'C':
          return 'Completely processed'
        case 'D':
          return 'Canceled'
        default:
          return `Unknown Status ${status}`
      }
    },
    remarksFormat(remarkString){
      if(remarkString==undefined){
        return ["",""]
      }
      var parsed= remarkString.split('\n');
      var lineOne= (parsed[0]==undefined)?"":parsed[0];
      var lineTwo= (parsed[1]==undefined)?"":parsed[1];
      
      return [lineOne,lineTwo]
    },
    dates(date) {
      return dateFormat(date);
    },
    datesWithTime(date){
      return dateFormatFullWithSecond(date)
    },
    customerName(purchase) {
      if (purchase.customer) {
        return purchase.customerDetail.nameFirst + " " + purchase.customerDetail.nameLast;
      } else {
        return (
          purchase.customerDetail.firstName +
          " " +
          purchase.customerDetail.lastName
        );
      }
    },
    formatter(value) {
      var number = value;
      if (!number) {
        number = 0;
      }
      return (Math.round(number * 100) / 100).toFixed(2);
    },
    toSales() {
      var sapSo = this.purchase.sapSo;
      var filterSO = this.salesOrders.find((x) => {
        return x.sapSo === sapSo;
      });
      this.$router.push({
        name: "sales-order-detail",
        params: { idSales: filterSO._id },
      });
    },
    async selectItem(row) {
      this.modalCheckStock = true
      const response = await axios.get(`sales-and-purchase/drcc/item/detail/${row.item.id}`);
      
      
      let data = response.data.data
      this.selectScan = {...data, ...row.item, replacementItem : data.replacementItem[0]};
      

      if (data.replacementItem?.length !== 0) {
        this.textItemReplacement = `${data.replacementItem[0].itemModel} - ${data.replacementItem[0].description}`
        this.itemReplacement = data.replacementItem[0]._id
      } else{
        this.textItemReplacement = "No item Replacement"
        this.itemReplacement = ""
      }
    },
    toDelivery(doDetail) {
      this.$router.push({
        name: "warehouse-detail-delivery",
        params: { id: doDetail.id, from: "other" },
      });
    },
    async printPO() {
      this.loading = true;
      try {
        var customerName = this.purchase.customerDetail.type === "Company"
          ? this.purchase.customerDetail.companyName
          : `${this.purchase.customerDetail.firstName} ${this.purchase.customerDetail.lastName}`;
        let docDefinition = {
          pageMargins: [70, 120, 70, 70],
          header: function(currentPage, pageCount, pageSize) {
            return [
              {
                image: `${header}`,
                alignment: "center",
                width: 520,
                margin: [0, 50, 0, 0],
              },
            ];
          },
          footer: function(currentPage, pageCount) {
            return [
              {
                image: `${footer}`,
                alignment: "center",
                width: 600,
                margin: [0, 0, 0, 50],
              },
            ];
          },
          content: [
            { text: 'Online Purchase Order to Daikin', style: 'header' },
            { text: '\n' },
            {
              layout: 'noBorders',
              table: {
                widths: ['20%', '1%', '79%'],
                headerRows: 1,
                body: [
                  [
                    { text: 'Customer PO', fontSize: 10 },
                    { text: ':', fontSize: 10 },
                    { text: this.poNumber[1], fontSize: 10 }
                  ],
                  [
                    { text: 'Online PO Ref:', fontSize: 10 },
                    { text: ':', fontSize: 10 },
                    { text: this.poNumber[0], fontSize: 10 }
                  ],
                  [
                    { text: 'Fulfillment Type', fontSize: 10 },
                    { text: ':', fontSize: 10 },
                    { text: this.purchase.orderType, fontSize: 10 }
                  ],
                  [
                    { text: 'SO Status', fontSize: 10 },
                    { text: ':', fontSize: 10 },
                    { text: this.sapStatus(this.purchase.sapStatus), fontSize: 10 }
                  ],
                  [
                    { text: 'Purchase Date', fontSize: 10 },
                    { text: ':', fontSize: 10 },
                    { text: this.dates(this.purchase.updatedAt), fontSize: 10 }
                  ],
                  [
                    { text: 'Delivery Date', fontSize: 10 },
                    { text: ':', fontSize: 10 },
                    { text: this.dates(this.purchase.deliveryDate), fontSize: 10 }
                  ],
                  [
                    { text: 'Email', fontSize: 10 },
                    { text: ':', fontSize: 10 },
                    { text: this.purchase.deliveryEmail, fontSize: 10 }
                  ],
                  [
                    { text: 'Delivery Type', fontSize: 10 },
                    { text: ':', fontSize: 10 },
                    { text: this.purchase.deliveryType, fontSize: 10 }
                  ],
                  [
                    { text: 'Customer Name', fontSize: 10 },
                    { text: ':', fontSize: 10 },
                    { text: customerName, fontSize: 10 }
                  ],
                  [
                    { text: 'Delivery Address', fontSize: 10 },
                    { text: ':', fontSize: 10 },
                    { text: [
                      this.purchase.customerDetail.address,
                      this.purchase.customerDetail.address2,
                      this.purchase.customerDetail.address3,
                      this.purchase.deliveryAddress,
                      this.purchase.deliveryAddress2,
                      this.purchase.deliveryAddress3
                    ].filter(Boolean).join('\n'), fontSize: 10 }
                  ],
                  [
                    { text: 'Remarks', fontSize: 10 },
                    { text: ':', fontSize: 10 },
                    { text: this.purchase.remarks || '', fontSize: 10 }
                  ]
                ]
              }
            },
            { text: '\n' },
            { text: 'Item Details', style: 'subheader' },
            {
              table: {
                widths: ['*', '*', '*', '*'],
                headerRows: 1,
                body: [
                  [
                    { text: 'Model', style: 'tableHeader' },
                    { text: 'Qty', style: 'tableHeader' },
                    { text: 'Unit Price', style: 'tableHeader' },
                    { text: 'Amount', style: 'tableHeader' }
                  ],
                  ...this.purchase.items.map(item => [
                    item.model,
                    item.qty.toString(),
                    this.formatter(item.price.$numberDecimal),
                    this.formatter(parseInt(item.price.$numberDecimal) * item.qty)
                  ])
                ]
              }
            },
            { text: '** Important Notes: 1) List Price is Indicative Only. 2) Ex-Stock Prior to Sales'},
            { text: '\n' },
            {
              layout: 'noBorders',
              table: {
                widths: ['*', '*'],
                body: [
                  [
                    { text: 'Subtotal:', alignment: 'right' },
                    { text: this.formatter(this.purchase.gstCalculation.total), alignment: 'right' }
                  ],
                  [
                    { text: `GST ${this.purchase.gstCalculation.gst}%:`, alignment: 'right' },
                    { text: this.formatter(this.purchase.gstCalculation.gst * this.purchase.gstCalculation.total / 100), alignment: 'right' }
                  ],
                  [
                    { text: 'Grand Total:', alignment: 'right', bold: true },
                    { text: this.formatter(this.purchase.gstCalculation.grandTotal), alignment: 'right', bold: true }
                  ]
                ]
              }
            }
          ],
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              alignment: 'center'
            },
            subheader: {
              fontSize: 14,
              bold: true,
              margin: [0, 10, 0, 5]
            },
            tableHeader: {
              bold: true,
              fontSize: 10,
              fillColor: '#f8f9fa'
            }
          }
        };

        if (pdfMake.vfs === undefined) {
          pdfMake.vfs = pdfFonts.pdfMake.vfs;
        }

        let fileName = `PO-${this.poNumber[0]}`;
        pdfMake.createPdf(docDefinition).download(fileName);
      } catch (error) {
        console.error('Error generating PDF:', error);
        this.$bvToast.toast('Error generating PDF', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        });
      } finally {
        this.loading = false;
      }
    },
    async handleStockStatus(status) {
      let available
      if (status == "Safe") {
        available = {
          availableQty : this.selectScan.qty,
          availableReplacementQty : 0,
          unitDiscountReplacement : 0
          
        }
      }else if(status == "Replacement Item Safe"){
        available = {
          availableQty : 0,
          availableReplacementQty : this.selectScan.qty,
          unitDiscount : 0,
          replacementItem : this.itemReplacement
        }
      }else{
        available = {
          availableQty : 0,
          availableReplacementQty : 0
        }
      }
      this.$store
        .dispatch("purchase/checkStockKioskPO", {
          id: this.id,
          data : {
            ...available,
            status,
            itemId: this.selectScan._id,
          }
        })
        .then(async (res)=>{
          this.modalCheckStock = false
          
          await this.$store
          .dispatch("purchase/detailPurchase", {
            id: this.id,
          })
          .then((res)=>{
            
          })
          .catch((err) => {
            console.error({ err });
          });

          const { items } = this.purchase;
          const allSafe = items.every(item => item.status == "Safe" )
          
          
          
          // if (allSafe) {
          //   this.modalInfo = true
          // }

          this.$bvToast.toast("Checking stock Kiosk Purchase Order Successfully", {
              title: "Success",
              variant: "success",
              solid: true,
            });
        })
        .catch((err) => {
          console.error({ err });
          this.$bvToast.toast("Checking stock Kiosk Purchase Order Failed", {
            title: "Failed",
            variant: "danger",
            solid: true,
          });
        });
      // Tambahkan logika sesuai kebutuhan
    },
    async handleStockStatusWithNote(status, note = '', availableQty = 0) {
      let available
      if (status == "Safe") {
        available = {
          availableQty : this.selectScan.qty,
          availableReplacementQty : 0,
          unitDiscountReplacement : 0
          
        }
      }else if(status == "Replacement Item Safe"){
        available = {
          availableQty : 0,
          availableReplacementQty : this.selectScan.qty,
          unitDiscount : 0,
          replacementItem : this.itemReplacement
        }
      }else{
        available = {
          availableQty : availableQty,
          availableReplacementQty : 0,
          note: note
        }
      }
      this.$store
        .dispatch("purchase/checkStockKioskPO", {
          id: this.id,
          data : {
            ...available,
            status,
            itemId: this.selectScan._id,
          }
        })
        .then(async (res)=>{
          this.modalCheckStock = false
          
          await this.$store
          .dispatch("purchase/detailPurchase", {
            id: this.id,
          })
          .then((res)=>{
            
          })
          .catch((err) => {
            console.error({ err });
          });

          const { items } = this.purchase;
          const allSafe = items.every(item => item.status == "Safe" )
          
          
          
          // if (allSafe) {
          //   this.modalInfo = true
          // }

          this.$bvToast.toast("Checking stock Kiosk Purchase Order Successfully", {
              title: "Success",
              variant: "success",
              solid: true,
            });
        })
        .catch((err) => {
          console.error({ err });
          this.$bvToast.toast("Checking stock Kiosk Purchase Order Failed", {
            title: "Failed",
            variant: "danger",
            solid: true,
          });
        });
    },
    confirmEditQtyTo(){
      this.$store
        .dispatch("purchase/checkStockKioskPO", {
          id: this.id,
          data : {
            status: "Replacement/Insufficient",
            itemId: this.selectScan._id,
            availableQty: this.selectScan.availableQty,
            replacementItem: this.itemReplacement,
            availableReplacementQty: this.selectScan.availableReplacementQty,
          }
        })
        .then((res)=>{
          this.itemReplacement = ""
          this.modalQtyEdit = false
          this.$store
            .dispatch("purchase/detailPurchase", {
              id: this.id,
            })
            .then((res)=>{

            })
            .catch((err) => {
              console.error({ err });
            });
            this.$bvToast.toast("Checking stock Kiosk Purchase Order Successfully", {
                title: "Success",
                variant: "success",
                solid: true,
              });
        })
        .catch((err) => {
          console.error({ err });
          this.$bvToast.toast("Checking stock Kiosk Purchase Order Failed", {
              title: "Failed",
              variant: "danger",
              solid: true,
            });
        });
    },
    confirmCheckStock() {
      const { items } = this.purchase;

      // Cek apakah semua items memiliki status (tidak undefined)
      const allHaveStatus = items.every(item => item.status);
      const allSafe = items.every(item => item.status == "Safe" 
      || (item.status == "Replacement Item Safe" && item.updatedReplacementQty > 0))
      if (!allHaveStatus) {
        this.$bvToast.toast("Please do stock checking to all items first", {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
        return;
      }

      if (allSafe) {
        this.modalSubmitPO = true
        this.modalTitle = "Change to Processing SO"
        this.messageModal = "Change status to Processing SO"

        return ;
      }
      // Cek status dalam items
      this.modalConfirmation = true
      this.modalTitle = "Change to Editing"
      this.messageModal = "Change status to editing"

      return ; // Jika semua status "Safe"
    },
    confirmEditPO(){
      this.modalConfirmation = true
      this.modalTitle = "Change to Editing"
      this.messageModal = "Change status to editing"
    },
    confirmEdit() {
      this.modalConfirmation = false
      let statusChange = 'Editing'
      let payloadData = { status : statusChange}
      this.$store
      .dispatch('purchase/editStatusKioskPo', {
        id : this.id, data : payloadData
      })
      .then(async (response) => {
        this.$bvToast.toast(`Edit Status Kiosk Purchase Order to ${statusChange}Successfully`, {
          title: "Success",
          variant: "success",
          solid: true,
        });
        this.$router.push({ name: 'kiosk-warehouse'});
      })
      .catch(async (e) => {
        console.error(e);
        this.$bvToast.toast("Edit status Kiosk Purchase Order Failed", {
            title: "Failed",
            variant: "danger",
            solid: true,
          });
      });
    },
    handleSapErrorClose() {
      this.modalSapError = false;
      this.$router.push({ name: 'kiosk-warehouse' });
    },
    handleInfoClose() {
      this.modalInfo = false;
    },
    showOutOfStockModal() {
      // Reset the out of stock data
      this.outOfStockData = {
        availableQty: 0,
        note: ''
      };
      this.modalCheckStock = false;
      this.modalOutOfStock = true;
    },
    confirmOutOfStock() {
      // Validate inputs
      if (!this.outOfStockData.note.trim()) {
        this.$bvToast.toast("Please enter a note", {
          title: "Validation Error",
          variant: "danger",
          solid: true,
        });
        return;
      }

      // Call handleStockStatus with the note and available quantity
      this.handleStockStatusWithNote('Out of Stock', this.outOfStockData.note, this.outOfStockData.availableQty);
      this.modalOutOfStock = false;
    },
    cancelOutOfStock() {
      this.modalOutOfStock = false;
      // Reset the data
      this.outOfStockData = {
        availableQty: 0,
        note: ''
      };
    },
    confirmPO(){
      //ini waktu klik confirm purchase dimana akan kirim PO ke SAP. dengan sebelumnya akan check stock dulu per item
      //for handling dealer info
      // this.disableButton = true;

      
      //this industryType
      // let mFormCopy = JSON.parse(JSON.stringify(this.purchase));
      // mFormCopy.customer = mFormCopy.customerDetail
      // if (mFormCopy.items.length <= 0) {
      //   this.$bvToast.toast("Please Add Item First", {
      //     title: "Failed",
      //     variant: "danger",
      //     solid: true,
      //   });
      //   this.disableButton = false;
      //   return;
      // }

      
      // this.addSaleKiosk(mFormCopy)
      //   .then(async (response) => {
          
      //     if(!response.data.success){
      //       this.disableButton = false;
      //       this.modalSubmitPO = false;
      //       sessionStorage.setItem("toastMessageError", "Submit Kiosk Purchase Order Failed");
      //       // Show the error modal instead of toast and redirecting immediately
      //       this.modalSapError = true;
      //       return;
      //     }

          this.disableButton = false;
          this.modalSubmitPO = false;
          sessionStorage.setItem("toastMessage", this.purchase.PONumber);
          this.$router.push({ name: 'kiosk-warehouse' });
      //   })
      //   .catch(async (e) => {
      //     this.disableButton = false;
      //     this.modalSubmitPO = false;
      //     sessionStorage.setItem("toastMessageError", "Submit Kiosk Purchase Order Failed");
      //     this.$router.push({ name: 'kiosk-warehouse' });
      //     await sleep(2000);
      //     // this.$router.push({ name: "order" });
      //   });
    }
  },
  computed: {
    // deliveryOrders() {
    //   return this.$store.getters["delivery/getDO"];
    // },
    purchase() {
      return this.$store.getters["purchase/purchaseById"];
    },
    poNumber(){
      if(this.purchase.length<=0){
        return ["",""]
      }
      var split = this.purchase.PONumber.split("*");
      return split;
    },
    salesOrders() {
      return this.$store.getters["sales/sales"];
    },
    permission() {
      let result = userAccess("Kiosk PO", "order_menu");
      return result;
    },
    showPrintButton() {
      const status = this.purchase.orderStatus;
      return status && !['Pending', 'Draft', '', 'PO Fail'].includes(status);
    },
    isCheckStockCompleteEnabled() {
      const { items } = this.purchase;
      if (!items || items.length === 0) return false;
      
      // Check if any item is still checking stock (status is undefined)
      const hasCheckingItems = items.some(item => !item.status);
      
      // Check if any item is out of stock
      const hasOutOfStockItems = items.some(item => item.status === 'Out of Stock');
      
      // Button is enabled only if no items are checking and no items are out of stock
      return !hasCheckingItems && !hasOutOfStockItems;
    }
  },
  mounted() {
    //this.$store.dispatch("delivery/getDeliveryOrder");
    this.$store.dispatch("sales/getSales", { orderStatus: "ALL" });

    this.$store
      .dispatch("purchase/detailPurchase", {
        id: this.id,
      })
      .then((res)=>{

      })
      .catch((err) => {
        console.error({ err });
      });
  },
};
</script>
